import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useShipments = () => useQuery({ queryKey: ['shipments'], queryFn: async () => {
    const callback = await API.get(`/common/shipments`)
    return callback?.data
}})

export default useShipments